var accountDataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');
var moment = require('moment');

module.exports = {
    1: {

    },
    2: {
        nameInfo: (data) => ({
            FirstName: data.stepState.firstName,
            MiddleName: data.stepState.middleName,
            LastName: data.stepState.lastName,
            NamePrefix: data.stepState.prefix,
            NameSuffix: data.stepState.suffix,
            password: data.stepState.password,
            credentials: data.stepState.credentials ? data.stepState.credentials.join(',') : ''
        }),
        saveApplicationInfoToSession: (data) => ({
            appType: data.appState.appType,
            productType: data.appState.productType,
            rateType: data.appState.rateType,
            isMilitary: data.appState.isMilitary,
            isGovernmentEmployee: data.appState.isGovernmentEmployee,
            applicationSubmitted: data.stepState.applicationSubmitted,
            yearsInPractice: data.appState.yearsInPractice
        }),
        primaryPracticeLocation: (data) => ({
            PrimaryPracticeLocation: data.stepState.primaryPracticeLocation,
            DistrictCode: data.stepState.primaryDistrictLocation
        })
    },
    3: {
        deleteGovernmentSector: (data) => {
            return data.stepState.governmentSectorIdToDelete ? [data.stepState.governmentSectorIdToDelete] : '';
        },
        addGovernmentSector: (data) => ([{
            SubDemographic: data.stepState.governmentSector
        }]),
        deleteMilitaryBranch: (data) => {
            return data.stepState.branchIdToDelete ? [data.stepState.branchIdToDelete] : '';
        },
        addMilitaryBranch: (data) => ([{
            SubDemographic : data.stepState.branch
        }]),
        demographicsInfo: (data) => ({
            jobtitle: "",
            gender: data.stepState.gender,
            birthdate: data.stepState.birthdate,
            ethnicity: data.stepState.ethnicity,
            race: data.stepState.race
        }),
        contactInformation: (data) => ({
            AddressId: data.stepState.addressId ? data.stepState.addressId : '',
            Address1: data.stepState.addressLine1,
            Address2: data.stepState.addressLine2,
            Address3: data.stepState.addressLine3,
            Address4: data.stepState.addressLine4,
            City: data.stepState.city,
            State: data.stepState.state,
            PostalCode: data.stepState.zip,
            CountryCode: data.stepState.country,
            AddressType: data.stepState.addressType,
            CompanyName: data.stepState.companyName,
            ShipToFlag: data.stepState.shipToFlag,
            BillToFlag: data.stepState.billToFlag,
            IsPrimary: data.stepState.isPrimaryAddress
        }),
        phone: (data) => ({
            PhoneNumber: data.stepState.phoneNumber,
            PhoneLocation: data.stepState.phoneLocation
        })
    },
    4: {
        primaryPractice: (data) => ({
            PrimaryPracticeLocation: data.stepState.primaryPracticeLocation,
            DistrictCode: data.stepState.primaryDistrictLocation
        }),
        primaryDistrict: (data) => ({
            DistrictCode: data.stepState.primaryDistrictLocation,
            PrimaryPracticeLocation: data.stepState.primaryPracticeLocation
        }),
        npiNumber: (data) => ({
            NpiNumber: data.stepState.npiNumber
        }),
        activeLicenses: (data) => {
            var licenses = [];

            if (data.stepState && data.stepState.activeLicenses && data.stepState.activeLicenses.length) {
                data.stepState.activeLicenses.map((license) => {

                    licenses.push({
                        AddedBy: '',
                        BeginDate: license.startDate,
                        ChangedBy: '',
                        Comments: '',
                        Country: 'USA',
                        EndDate: license.expireDate,
                        EntityGUID: license.entityGuid,
                        LicenseID: license.entityGuid ? license.id : '', 
                        State: license.state,
                        SubCustomerId: 0
                    });
                });
            }

            return licenses;
        },
        boardCertifications: (data) => {
            var boardId = apiDataConstants.boardCertificationCodes.getId(data.stepState.boardCertification);
            if (boardId) {
                return [{
                    CusDemographicId: data.stepState.boardCertificationId ? data.stepState.boardCertificationId : '',
                    SubDemographic: boardId,
                    Number: data.stepState.boardCertificationNumber,
                    BeginDate: data.stepState.boardCertificationDate
                }];
            }
        },
        // depending on the current board, we may have to delete old subboard selections tied to a different board
        boardCredentialsDeletes: (data) => {
            var toDelete = [];
            if (data.stepState.boardCertification === 'Not Certified' || !data.stepState.hasBoardSubSpecialty) {
                data.stepState.boardSubSpecialties.map((sub) => {
                    toDelete.push(sub.CusDemographicId);
                });
            }

            if (data.stepState.boardCertification === 'ABA') {
                data.stepState.boardSubSpecialties.map((sub) => {
                    if ((sub.SubDemographic && sub.SubDemographic.indexOf('AOBA') === 0) || (sub.Subcode && sub.Subcode.indexOf('AOBA') === 0)) {
                        toDelete.push(sub.CusDemographicId);
                    }
                });
            }

            if (data.stepState.boardCertification === 'AOBA') {
                data.stepState.boardSubSpecialties.map((sub) => {
                    if ((sub.SubDemographic && sub.SubDemographic.indexOf('ABA') === 0) || (sub.Subcode && sub.Subcode.indexOf('ABA') === 0)) {
                        toDelete.push(sub.CusDemographicId);
                    }
                });
            }

            data.stepState.boardSubSpecialtiesToDelete.filter((sub) => {
                return sub.CusDemographicId != 0;
            }).map((sub) => {
                toDelete.push(sub.CusDemographicId);
            });

            return toDelete;
        },
        // POST any credentials without a CusDemographicId, which would indicate they are newly added
        // NOTE - in certain use cases, it is possible that this code will post a subboard that already exists for the user.
        // The API is smart enough to handle this scenario; the subboard will NOT get added twice
        boardCredentialsAdds: (data) => {
            return data.stepState.boardSubSpecialties.filter((sub) => {
                return !sub.CusDemographicId;
            }).map((sub) => {
                return {
                    CusDemographicId: '',
                    SubDemographic: sub.SubDemographic ? sub.SubDemographic : sub.Subcode,
                    Number: 0,//empty string was causing error.
                    BeginDate: sub.BeginDate
                }
            });
        }
    },
    5: {
        medSchool: (data) => {
            var progTypeString = (progTypeName) => {
                return progTypeName && progTypeName.toLowerCase().indexOf('training') >= 0
                    ? apiDataConstants.programTypeCodes.training
                    : apiDataConstants.programTypeCodes.medSchool;
            }

            return [{
                BeginDate: data.stepState.medSchoolStartDate,
                EndDate: data.stepState.medSchoolEndDate,
                InstitutionName: data.stepState.medSchoolInstitution,
                CustomInstitutionName: data.stepState.medSchoolCustomInstitution,
                ProgDegreeCodeString: apiDataConstants.programDegreeCodes.notApplicable,
                ProgTypeCodeString: progTypeString(data.stepState.medSchoolProgramType),
                UserDefinedCountryCodeString: data.stepState.medSchoolCountry,
                UserDefinedState: data.stepState.medSchoolState,
                CustomerEducationId: data.stepState.medSchoolCustomerEducationId
            }];
        },
        residency: (data) => {
            return [{
                BeginDate: data.stepState.residencyStartDate,
                EndDate: data.stepState.residencyEndDate,
                InstitutionName: data.stepState.residencyInstitution,
                CustomInstitutionName: data.stepState.residencyCustomInstitution,
                ProgDegreeCodeString: apiDataConstants.programDegreeCodes.notApplicable,
                ProgTypeCodeString: apiDataConstants.programTypeCodes.residency,
                UserDefinedCountryCodeString: data.stepState.residencyCountry,
                UserDefinedState: data.stepState.residencyState,
                CustomerEducationId: data.stepState.residencyCustomerEducationId
            }];
        },
        fellowships: (data) => {
            var records = [];

            if (data && data.stepState && data.stepState.fellowships && data.stepState.fellowships.length) {
                data.stepState.fellowships.map((item) => {
                    records.push({
                        BeginDate: item.startDate,
                        EndDate: item.endDate,
                        InstitutionName: item.institution,
                        CustomInstitutionName: item.customInstitution,
                        ProgDegreeCodeString: apiDataConstants.programDegreeCodes.notApplicable,
                        ProgTypeCodeString: apiDataConstants.programTypeCodes.fellowship,
                        UserDefinedCountryCodeString: item.country,
                        UserDefinedState: item.state,
                        UserDefinedFellowshipCodeString: item.type, //
                        UserDefinedFellowshipSubcodeString: item.subtype,
                        CustomerEducationId: item.customerEducationId ? item.customerEducationId : ''
                    });
                });
            }

            return records;
        }
    },

    6: {
        paymentInfo: (data) => {
            return {
                Amount: data.appState.priceTotal,
                CurrencyCode: "USD",
                CreditCardNumber: data.stepState.ccNumber,
                ExpirationMonth: data.stepState.ccExpirationMonth,
                ExpirationYear: data.stepState.ccExpirationYear,
                Cvv2: data.stepState.ccSecurityCode,
                NameOnCard: data.stepState.ccName,
                BillingAddressStreet: data.stepState.addressLine1 + ' ' + data.stepState.addressLine2 + ' ' + data.stepState.addressLine3,
                BillingAddressCity: data.stepState.city,
                BillingAddressState: data.stepState.state,
                BillingAddressPostalCode: data.stepState.zip,
                BillingAddressCountryCode: data.stepState.country,
                RenewCCFlag: data.stepState.autorenewflag,

                // these fields used for creating the order
                OrderNumber: data.appState.orderNumber,
                ProductId: data.appState.productId,
                Quantity: 1,
                RateStructure: data.appState.rateType,
                RateCode: data.appState.rateCode,
                //BaseUnitPrice: data.appState.membershipPrice, -- doubling the price for ECM orders. If we don't send it, Personify can calculate based on rules setup in the system 
                StateComponentOptOut: data.appState.stateComponentDuesOptOut,
                ParticipantProductId: data.appState.productId
            }
        }
    }
}